import React, { Component } from "react";
import Window from "../2/Controls/Window";
// import { database } from "../../firebase";
import axios from "axios";
import Spinner from "../Common/Spinner";

class PincodeAPIlogs extends Component {
  constructor() {
    super();
    this.state = {
      showAPILogs: false,
      apiLogs: [],
      loading: false,
    };
    this.loadAPILogs = this.loadAPILogs.bind(this);
  }

  componentDidMount() {}

  // async loadAPILogs() {
  //   let apiLogs = await database
  //     .collection("PincodeApiLogs")
  //     .where("ProductID", "==", this.props.productID)
  //     .orderBy("ActtionOn", "desc")
  //     .limit(2000)
  //     .get()
  //     .then((querySnapshot) => {
  //       let apiLogs = [];
  //       querySnapshot.forEach((doc) => {
  //         apiLogs.push({ ...doc.data() });
  //       });
  //       console.log("apiLogs", apiLogs);
  //       return apiLogs;
  //     });

  //   this.setState({ apiLogs: apiLogs, showAPILogs: true });
  // }

  async loadAPILogs() {
    try {
      this.setState({ loading: true, showAPILogs: true });
      let apiLogs = [];
      const BaseURL = "https://backend-197598313260.asia-south1.run.app";
      const response = await axios.get(
        `${BaseURL}/v2/catalog/products/api-logs`,
        {
          params: {
            productID: this.props.productID,
          },
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      // console.log("loadAPILogs response.data", response.data);
      apiLogs = response.data.apiLogs;

      // }
      this.setState({ apiLogs: apiLogs, showAPILogs: true, loading: false });
    } catch (error) {
      // console.error("GET API Error:", error.message);
      // throw error; // throw error so calling function can handle it
    }
  }

  render() {
    return (
      <React.Fragment>
        <a onClick={() => this.loadAPILogs()}>API Logs</a>

        {this.state.showAPILogs && (
          <Window
            header={"API Logs"}
            width={"600px"}
            onClose={() => this.setState({ showAPILogs: false })}
            onButtonClick={(buttonType) => {
              this.setState({ showAPILogs: false });
            }}
            buttons={[]}
          >
            {this.state.loading && <Spinner />}
            <div
              className="box-body scroll2"
              style={{ width: "auto", overflowX: "auto", height: "400px" }}
            >
              <table className="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>Date & time</th>
                    <th>Action Performed</th>
                    <th>Payload</th>
                    <th>Response</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.apiLogs.map((apiLog, index) => (
                    <tr key={index}>
                      <td>
                        {/* {new Date(apiLog.ActtionOn.seconds * 1000)
                          .toString()
                          .substring(0, 24)} */}
                        {apiLog.ActionOn}
                      </td>
                      <td>{apiLog.ActionBy}</td>
                      <td> {JSON.stringify(apiLog.Log)}</td>
                      <td>
                        {" "}
                        {apiLog.Response && (
                          <>{JSON.stringify(apiLog.Response)}</>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Window>
        )}
      </React.Fragment>
    );
  }
}

export default PincodeAPIlogs;
